import { combineReducers } from 'redux';
import accounts, { IAccountsState } from './accounts';
import current, { ICurrentState } from './current';
import watchlist, { IWatchlistState } from './watchlist';
import tickers from './tickers';
import grid, { IGridState } from './grid';
import dex_trades, { IDexTradesState } from './dex_trades';
import blockchains, { IBlockChainsState } from './blockchains';
import modal, { IModalReducerState } from './modal';
import layout, { ILayoutState } from './layout';
import chartPicker, { IChartPicker } from './chart_picker';
import rates, { IRatesReducer } from './rates';
import transactions, { IIntermediateTransaction } from './transactions';
import modalSearch, { IModalSearch } from './modalSearch';
import notifs from './notifications';
import news, { INewsState } from './news';
import trendingReducer, { ITrendingReducer } from './trending';
import price_alerts, { IPriceAlertsState } from './price_alerts';
import price_changes, { IPriceChangesState } from './price_changes';
import limitOrders, { ILimitOrdersState } from './limitOrders';
import auth, { IAuthState } from './auth';

export interface IStore {
  accounts: IAccountsState;
  current: ICurrentState;
  watchlist: IWatchlistState;
  tickers: any;
  dex_trades: IDexTradesState;
  transactions: IIntermediateTransaction[];
  blockchains: IBlockChainsState;
  modal: IModalReducerState;
  layout: ILayoutState;
  chartPicker: IChartPicker;
  rates: IRatesReducer;
  modalSearch: IModalSearch;
  notifs: any[];
  news: INewsState;
  grid: IGridState;
  trendingReducer: ITrendingReducer;
  price_alerts: IPriceAlertsState;
  price_changes: IPriceChangesState;
  limitOrders: ILimitOrdersState;
  auth: IAuthState;
}

export default combineReducers({
  accounts,
  current,
  watchlist,
  tickers,
  dex_trades,
  transactions,
  blockchains,
  modal,
  layout,
  chartPicker,
  rates,
  modalSearch,
  notifs,
  news,
  grid,
  trendingReducer,
  price_alerts,
  price_changes,
  limitOrders,
  auth,
});
